import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=5be15d55&scoped=true&"
import script from "./InformationDialog.vue?vue&type=script&lang=js&"
export * from "./InformationDialog.vue?vue&type=script&lang=js&"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=5be15d55&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be15d55",
  null
  
)

export default component.exports